<template>
  <div id="RuleTemplateEditDialog">
    <el-dialog :title="title" width="540px" :visible.sync="isVisibleTemp" @close="closeAndclear('ruleTemplateInfo')">
      <el-form :label-position="labelPosition" :model="ruleTemplateInfo" :rules="rules" ref="ruleTemplateInfo">
        <el-form-item label="模板编号" :label-width="formLabelWidth">
          <el-input v-model="ruleTemplateInfo.templateCode" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="模板名称" :label-width="formLabelWidth" prop="templateName">
          <el-input class="eb-input panel-body-row-right" v-model="ruleTemplateInfo.templateName" auto-complete="off" :disabled="!ruleTemplateInfo.isCanEditTplName"></el-input>
        </el-form-item>
        <el-form-item label="模板备注" :label-width="formLabelWidth">
          <el-input type="textarea" class="eb-textarea" :rows="2" v-model="ruleTemplateInfo.templateMemo" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否公开" prop="publicState">
          <el-radio-group v-model="ruleTemplateInfo.publicState">
            <el-radio label="1">公开</el-radio>
            <el-radio label="0">不公开</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="closeAndclear('ruleTemplateInfo')">关闭</el-button>
        <el-button v-if="ruleTemplateInfo.operType === 'add'" class="eb-button-group-btn eb-button-orange eb-button-big" @click="addTpl">确定</el-button>
        <el-button v-else-if="ruleTemplateInfo.operType === 'edit'" class="eb-button-group-btn eb-button-orange eb-button-big" @click="editTpl">确定</el-button>
        <el-button v-else class="eb-button-group-btn eb-button-orange eb-button-big" @click="copyTpl">确定</el-button>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import {
  isDefRuleTemplateName,
  addRuleTmeplate,
  copyRuleTemplate,
  editRuleTemplate
} from '@/services/rule/rule-template-service';
export default {
  props: {
    ruleTemplateInfo: {
      type: Object
    },
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      formLabelWidth: '120px',
      labelPosition: 'top',
      rules: {
        templateName: [
          { required: true, message: '请输入模板名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        templateMemo: [{ min: 2, max: 200, message: '长度在 2 到 200 个字符', trigger: 'blur' }],
        publicState: [{ required: true, message: '请选择是否公开', trigger: 'blur' }]
      },
      isCanEditTplName: false
    };
  },
  computed: {
    title() {
      if (this.ruleTemplateInfo.operType === 'add') {
        return '新增规则模板';
      } else {
        return '复制规则模板';
      }
    },
    isVisibleTemp: {
      get: function() {
        return this.isVisible;
      },
      set: function(val) {
        this.$emit('update:isVisible', val);
      }
    }
  },
  methods: {
    addTpl() {
      this.$refs['ruleTemplateInfo'].validate(async valid => {
        if (!valid) {
          return;
        }
        if (isDefRuleTemplateName(this.ruleTemplateInfo.templateName)) {
          this.$message.error('不可以使用默认模板名称');
          return;
        }
        try {
          let { data } = await addRuleTmeplate(this.ruleTemplateInfo);
          if (data.returnCode === '01') {
            this.isVisibleTemp = false;
            this.$message.success('新增规则模板成功');
            this.$router.push('/v2/rule/template/edit/' + data.templateId);
            // this.$emit('ruleTmeplateSuccess');
          } else if (data.returnCode === '03') {
            this.$message.error('参数不完整');
          } else {
            this.$message.error('新增规则模板失败');
          }
        } catch (err) {
          this.$message.error(err);
        }
      });
    },
    copyTpl() {
      this.$refs['ruleTemplateInfo'].validate(async valid => {
        if (!valid) {
          return;
        }
        if (isDefRuleTemplateName(this.ruleTemplateInfo.templateName)) {
          this.$message.error('不可以使用默认模板名称');
          return;
        }
        try {
          let { data } = await copyRuleTemplate(this.ruleTemplateInfo);
          if (data.returnCode === '01') {
            this.isVisibleTemp = false;
            this.$message.success('规则模板复制完成');
            this.$emit('ruleTmeplateSuccess');
          } else if (data.returnCode === '03') {
            this.$message.error('参数不完整');
          } else {
            this.$message.error('复制规则模板失败');
          }
        } catch (err) {
          this.$message.error(err);
        }
      });
    },
    editTpl() {
      this.$refs['ruleTemplateInfo'].validate(async valid => {
        if (!valid) {
          return;
        }
        if (this.ruleTemplateInfo.isCanEditTplName) {
          if (isDefRuleTemplateName(this.ruleTemplateInfo.templateName)) {
            this.$message.error('不可以使用默认模板名称');
            return;
          }
        }

        try {
          let { data } = await editRuleTemplate(this.ruleTemplateInfo);
          if (data.returnCode === '01') {
            this.isVisibleTemp = false;
            this.$message.success('修改规则模板成功');
            this.$emit('ruleTmeplateSuccess');
          } else if (data.returnCode === '03') {
            this.$message.error('参数不完整');
          } else if (data.returnCode === '05') {
            this.$message.error('您没有修改此模板的权限');
          } else {
            this.$message.error('复制规则模板失败');
          }
        } catch (err) {
          this.$message.error(err);
        }
      });
    },
    closeAndclear(ruleTemplateInfo) {
      this.isVisibleTemp = false;
      this.$refs[ruleTemplateInfo].resetFields();
    }
  }
};
</script>
<style lang="less">
#RuleTemplateEditDialog {
  .el-form-item {
    margin-bottom: 15px;

    .el-form-item__label {
      padding-bottom: 0px;
      line-height: 30px;
    }
  }
}
</style>
